import React from "react";
import EventList from "../../components/faceswap/category/event-list";

export default function Api() {
  return <EventList />;
}
